import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Context } from "./Utils/Store";
import axios from "axios";
import Button from "@mui/material/Button";
import { getAppSettings } from "./Utils/AppSettings"
import { formatNumber } from "./Utils/Formatters";
import "./css/App.css";

function Trips() {

  const history = useHistory();
  const [store, setStore] = useContext(Context);
  const tripData = useRef([]);
  const [tripItems, setTripItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleBack = () => {
    history.goBack();
  }

  const handleAdd = () => {

    const trip = {
      TLKey: 0,
      EMKey: store.driver.EMKey,
      PeriodDate: String(store.driver.PeriodEnd).slice(0, 10),
      WorkDate: store.WorkDay,
      RouteNumber: store.driver.RouteNumber,
      JobCode: String(store.driver.JobCode).slice(-2),
      CustomerNumber: store.driver.CustomerNumber,
      StudentCount: 0,
      BeginTime: "",
      EndTime: "",
      BeginOdometer: 0,
      EndOdometer: 0
    }

    setStore({ type: "TRIP", payload: trip });

    history.push({
      pathname: "Data"
    });
}

  useEffect(() => {

    const formatTime = (val) => {
      let hour = Number(val.slice(0,2));
      let ampm = hour === 12 ? "PM" : "AM";

      if ( hour >= 13 ) {
        hour -= 12;
        ampm = "PM";
      }

      return val ? String("00"+hour).slice(-2) + val.slice(2) + " " + ampm : "--:-- --";
    }

    const listTrips = (data) => {
      const dayTrips = []
      data.map((item, index) => {
        let timeClass = "triptimes";
        if (item.Locked) {
          timeClass += " triplocked";
        } else {
          if (item.BeginTime === "" || item.EndTime === "" || item.EndTime <= item.BeginTime) {
              timeClass += " tripmissed"
          }
        }
        let routeValue = item.RouteNumber;
        if (item.RouteNumber.length === 0) {
          if (item.JobCode === "12" || item.JobCode === "13" || item.JobCode === "14" ||item.JobCode === "15" || item.JobCode === "17" || item.JobCode === "23") {
            routeValue = "Work";
          } else {
            routeValue = "Route";
          }
        }
        dayTrips.push(<div className="tripbox" key={"tr-"+index} tlkey={item.TLKey} onClick={item.Locked ? null : handleTrip}>
          <div className={timeClass} tlkey={item.TLKey}>{formatTime(item.BeginTime)}</div>
          <div className={item.Locked ?"triproute triplocked":"triproute"} tlkey={item.TLKey}>{routeValue}</div>
          <div className={item.Locked ?"triphours triplocked":"triphours"} tlkey={item.TLKey}>{formatNumber(item.GuaranteedHours, 2)}</div>
        </div>);
        return null;
      });
      setTripItems(dayTrips);
    }

    const handleTrip = (e) => {
      const tlkey = e.target.attributes.tlkey.value;

      let trip = {};
      for (let n = 0; n < tripData.current.length; n++) {
        if (String(tripData.current[n].TLKey) === tlkey) {
          trip = tripData.current[n];
          break;
        }
      }

      setStore({ type: "TRIP", payload: trip });

      history.push({
        pathname: "Data"
      });
    }

    const tripObject = {
      EMKey: store.driver.EMKey,
      WorkDay: store.workday
    };

    const settings = getAppSettings();

    if (loading) {
      axios.post(settings.apiUrl + '/driver/loadtrips', tripObject).then(response => {
        setLoading(false);
        if (response.status === 200) {
          tripData.current = response.data;
          listTrips(response.data);
        } else {
          console.log("response status: " + response.status + " " + response.statusText);
        }
      }).catch(error => {
        setLoading(false);
        console.log(error);
      });
    }
  }, [loading, history, store, setStore, tripData]);

  return (
    <div className="page">
      <div className="vbox">
        <div className="employee">{store.driver.DriverName}</div>
        <div><b>{store.daylabel} TRIPS</b></div>
        <div className="spacer10x20" />
        <div><b>Tap to Add/Edit Trip</b></div>
      </div>
      <div className="spacer10x20" />
      <div className="vbox trips">
        {tripItems}
        <div className="tripadd" onClick={handleAdd}>Add New Trip</div>
      </div>
      <div className="spacer10x40" />
      <Button variant="contained" onClick={handleBack}>BACK</Button>
    </div>
  );
}

export default Trips;
